import { useUserBehaviorEvents } from '~/composables/tracking-events/use-user-behavior-events'

export function useTimeOnPage() {
  let enterTime: number
  const router = useRouter()
  const route = useRoute()
  const { trackingTimeSpentOnPage } = useUserBehaviorEvents()

  const startTracking = () => {
    enterTime = Date.now()
  }

  const stopTracking = () => {
    const timeSpent = (Date.now() - enterTime) / 1000 // Time spent in seconds
    const params = {
      pageUrl: route.fullPath,
      timeSpent,
    }
    trackingTimeSpentOnPage(params)
  }

  onMounted(() => {
    startTracking()
  })

  onBeforeUnmount(() => {
    stopTracking()
  })


  router.beforeEach(() => {
    stopTracking()
    startTracking()
  })

  return {
    startTracking,
    stopTracking,
  }
}
